module.exports = __webpack_public_path__ + "static/media/outfit13.79e6f473.jpg";